export default __webpack_public_path__ + "static/media/chart-01.61246d8f.svg";